import { useReducer } from "react";

// Pure UI-panel state for the registered view. All registration mutations
// (add / remove / to-solo / rename / cancel) now commit immediately via the
// shared onAction handler, so there is nothing to "stage" — this just tracks
// which inline panel is open.
export interface PanelState {
  editingName: boolean;
  showSwitchToTeam: boolean;
  showAddSearch: boolean;
}

export type PanelAction =
  | { type: "start_edit_name" }
  | { type: "stop_edit_name" }
  | { type: "set_show_switch_to_team"; value: boolean }
  | { type: "set_show_add_search"; value: boolean }
  | { type: "reset" };

const initialPanel: PanelState = {
  editingName: false,
  showSwitchToTeam: false,
  showAddSearch: false,
};

function panelReducer(state: PanelState, action: PanelAction): PanelState {
  switch (action.type) {
    case "start_edit_name":
      return { ...state, editingName: true };
    case "stop_edit_name":
      return { ...state, editingName: false };
    case "set_show_switch_to_team":
      return { ...state, showSwitchToTeam: action.value };
    case "set_show_add_search":
      return { ...state, showAddSearch: action.value };
    case "reset":
      return initialPanel;
    default:
      return state;
  }
}

export function usePanelState() {
  return useReducer(panelReducer, initialPanel);
}
